import React from 'react';
import PropTypes from 'prop-types';
import SessionsSignInForm from '../../Sessions/SessionsSignInForm';

export default function SigninPage({ sign_in_endpoint }) {
	if (!sign_in_endpoint) {
		return <div>Error: Missing sign-in endpoint</div>;
	}

	return (
		<div>
			<SessionsSignInForm endpoint={sign_in_endpoint} />
		</div>
	);
}

SigninPage.propTypes = {
	sign_in_endpoint: PropTypes.string.isRequired
};
